import React, { useEffect, useState } from "react";
import { GlobalFilter } from "../../components/table/FilteringTable/GlobalFilter";
import { Table } from "antd";
import { deleteRole, fetchAllRoles } from "../../../services/RolesServices";
import formatError from "../../../services/FormatError";
import RolesModal from "./components/RolesModal";
import { columns } from "./components/utils";
import swal from "sweetalert";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

const RolesManagement = () => {
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [allRoles, setAllRoles] = useState([]);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [viewOrEdit, setViewOrEdit] = useState("none");
  const [selectedRole, setSelectedRole] = useState({});

  const { t } = useTranslation();

  useEffect(() => {
    getAllRoles();
  }, []);

  const getAllRoles = () => {
    fetchAllRoles()
      .then((res) => {
        const response = res?.data?.result;
        setAllRoles(response?.data);

        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: response?.length,
        }));
        setLoading(false);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
        setLoading(false);
      });
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const onHideModal = () => {
    setSelectedRole({});
    setShowAddModal(false);
  };

  const handleBtnClick = () => {
    setSelectedRole({});
    setViewOrEdit("none");
    setShowAddModal(true);
  };

  const deleteHandler = (id) => {
    try {
      deleteRole(id)
        .then((res) => {
          getAllRoles();
          swal("Success", "Role Deleted successfully", "success");
        })
        .catch((error) => {
          if (error.response.status === 403) {
            swal(
              "Not Authorize",
              "You are not Authorize to Delete role",
              "error"
            );
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const filterItems = allRoles?.filter((item) => {
    const isNameMatch =
      !searchTerm ||
      item?.name?.toLowerCase().includes(searchTerm.toLowerCase());
    return isNameMatch;
  });
  return (
    <div class="card">
      {loading && <Loader forProcess={true} />}
      <div className="card-header d-sm-flex d-block">
        <div className="me-auto mb-sm-0">
          <h4 className="card-title">{t("roles_and_permissions")}</h4>
        </div>
        <GlobalFilter filter={searchTerm} setFilter={setSearchTerm} />
        <button
          className="btn btn-info light px-2 ms-4"
          onClick={handleBtnClick}
        >
          {t("add_new_role")}
        </button>
      </div>

      <div class="card-body">
        <Table
          columns={columns(
            setViewOrEdit,
            setShowAddModal,
            setSelectedRole,
            tableParams,
            deleteHandler,
            t
          )}
          rowKey={(record) => record.id}
          dataSource={filterItems}
          pagination={tableParams}
          onChange={handleTableChange}
        />
      </div>

      {/* add modal */}
      <RolesModal
        onHideModal={onHideModal}
        showAddModal={showAddModal}
        setShowAddModal={setShowAddModal}
        viewOrEdit={viewOrEdit}
        selectedRole={selectedRole}
        getAllRoles={getAllRoles}
        setSelectedRole={setSelectedRole}
      />
    </div>
  );
};

export default RolesManagement;
